/* eslint-disable indent */
import React from 'react';

import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { defaultGraphConfig, generateLabels } from 'utils/graphs';
import {
  AvgMaxCountAccess,
  PerformanceMemoryGraphFields,
} from 'modules/environments/interfaces';
import { roundToFixedTwoWithPercentage } from 'utils/helpers';

interface MemoryGraphProps {
  filter: AvgMaxCountAccess | string;
  environmentPerformanceMemory: PerformanceMemoryGraphFields;
}

const MemoryGraph = ({
  filter,
  environmentPerformanceMemory,
}: MemoryGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(environmentPerformanceMemory?.metrics);

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: environmentPerformanceMemory?.metrics?.map(
          filter === 'avg'
            ? item => item?.memory?.avg
            : item => item?.memory?.max
        ),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
    ],
  });

  config.options.scales.xAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.beginAtZero = true;
  config.options.scales.yAxes[0].ticks.max = 100;
  config.options.tooltips = {
    callbacks: {
      label(tooltipItem) {
        return roundToFixedTwoWithPercentage(tooltipItem.value);
      },
    },
    displayColors: false,
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentPerformanceMemory },
}: ApplicationState) => ({
  environmentPerformanceMemory,
});

export default connect(mapStateToProps, {})(MemoryGraph);
